enum Routes {
  NEW_PROJECT = '/projects/new',
}
export default Routes;
